export default "__VITE_ASSET__Xbc9XHz6__"